import React from 'react';

const BookListItem = ({ book, dumy = false }) => {

    if (dumy === true) {
        return (
            <div className="book_wrap dumy">
                <div className="book_cover">
                    <div className="book_inner">
                    </div>
                </div>
                <div className="book_info">
                    <div className="title">...</div>
                    <div className="writer">...</div>
                    <div className="pb_company">...</div>
                </div>
            </div>
        );
    }

    if (book == null) return null;
    return (
        <div className="book_wrap">
            <div className="book_cover">
                <div className="book_inner">
                    <img src={book.image ? book.image : `${process.env.PUBLIC_URL}/static/images/userbook/userbook_cover_no_image.jpg`} alt={book.title} />
                    <div className={`service service_${book.isService?.toLowerCase()}`}></div>
                    {book.isService === 'Y' && book.student_workbook === 'Y' && <div className="workbook student"></div>}
                    {book.isService === 'Y' && book.teacher_workbook === 'Y' && <div className="workbook teacher"></div>}
                </div>
            </div>
            <div className="book_info">
                <div className="title">{book.title}</div>
                <div className="writer">{book.author}</div>
                <div className="pb_company">{book.publisher}</div>
            </div>
        </div>
    );
}//end
export default BookListItem;